import { call, fork, put, take } from 'redux-saga/effects';
import {Api} from '../api';
import {Booking} from '../api/types';
import {enqueueErrorSnackbar} from '../action/snackbarCommands';
import {getI18n} from 'react-i18next';
import Logger from '../common/logger';
import { visitorBookingsFetched } from '../action/bookingsEvents';
import { fetchVisitorBookings } from '../action/bookingsCommands';

export const onFetchVisitorBookings = function*() {
    try {
        const visitorBookings: Booking[] = yield call(Api.getVisitorBookings);

        yield put(visitorBookingsFetched({ visitorBookings }));
    } catch (e) {
        Logger('Saga').error(e);
        yield put(enqueueErrorSnackbar({ message: getI18n().t('snackbar.error.fetch_issueReports') }));
    }
};

export function* fetchVisitorBookingsFlow() {
    while (true) {
        yield take(fetchVisitorBookings.toString());

        yield fork(onFetchVisitorBookings);
    }
}
